import { render, staticRenderFns } from "./Carta.vue?vue&type=template&id=3e788dba&scoped=true&"
import script from "./Carta.vue?vue&type=script&lang=js&"
export * from "./Carta.vue?vue&type=script&lang=js&"
import style0 from "./Carta.vue?vue&type=style&index=0&id=3e788dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e788dba",
  null
  
)

export default component.exports